
function Post({ image, PostHead, date, time, authorName, slug }) {
    return (
        <div className="col-lg-4 col-md-6 mt-md-0 mt-4">
            <div className="top-pic1" style={{ backgroundImage: `url(${image})` }} onClick={() => { window.location = `/posts/${slug}` }}>
                <div className="card-body blog-details">
                    <a href={`/posts/${slug}`} className="blog-desc"> {PostHead} </a>
                    <div className="author align-items-center">
                        <img src="https://amanojha.pythonanywhere.com/media/Aman_Ojha.jpg" alt='' className="img-fluid rounded-circle" />
                        <ul className="blog-meta">
                            <li>
                                <a href="https://amanojha.pythonanywhere.com">{authorName}</a>
                            </li>
                            <li className="meta-item blog-lesson">
                                <span className="meta-value"> {date} </span>. <span className="meta-value ml-2"><span className="fa fa-clock-o" /> at {time}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Post
